// extracted by mini-css-extract-plugin
module.exports = {"SelectVillage":"SelectVillage_SelectVillage__3292f","footer":"SelectVillage_footer__PHaiO","DeleteAccount":"SelectVillage_DeleteAccount__D1LaB"};